<template>
  <div class="container">
    <div
      class="temporary_show-container"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      v-if="feedbackList.length === 0"
    >
      暂无数据
    </div>
    <div class="feedback-list">
      <div
        class="feedback-list_item"
        v-for="(item, index) in feedbackList"
        :key="item.id"
      >
        <router-link
          :to="{ name: 'my_feedback_edit', params: { id: item.id } }"
        >
          <img
            :src="((item.courseware || {}).image || {}).file_src"
            class="item-image"
          />
        </router-link>
        <div class="item-content">
          <p class="item-content-title">{{ item.courseware.name }}</p>
          <p class="item-content-desc">{{ item.remarks }}</p>
        </div>
        <div class="item-operation">
          <router-link
            :to="{ name: 'my_feedback_edit', params: { id: item.id } }"
          >
            <el-button plain size="small" class="edit-button">编辑</el-button>
          </router-link>
          <el-button
            style="margin-left: 8px"
            type="danger"
            size="small"
            @click="del(item, index)"
            >删除</el-button
          >
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="editCurrentPage"
      :hide-on-single-page="true"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import userService from "@/global/service/user";

export default {
  data() {
    return {
      feedbackList: [],
      pageSize: 10,
      pageCount: null,
      currentPage: 1,
      total: null,
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    del(item, index) {
      this.$confirm("确认删除该条反馈？").then(() => {
        userService.coursewareFeedBackDelete(item.id).then(() => {
          this.feedbackList.splice(index, 1);
          this.$message.success("删除成功");
        });
      });
    },
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      userService
        .coursewareFeedBack(params)
        .then(res => {
          this.feedbackList = res.list;
          this.total = res.pagination.total;
          this.currentPage = res.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.feedback-list {
  background-color: #f4f4f4;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .feedback-list_item {
    margin-bottom: 20px;
    background-color: #fff;
    width: 340px;

    .item-image {
      width: 100%;
      height: calc(100vh / 3);
      object-fit: cover;
    }
    .item-content {
      text-align: left;
      .item-content-title {
        padding: 10px;
        font-size: 14px;
        color: #333;
        line-height: 30px;
        border-bottom: 1px solid #dedede;
      }
      .item-content-desc {
        font-size: 12px;
        color: #666666;
        padding: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    .item-operation {
      padding: 0 10px 10px;
      text-align: left;
    }
  }
  .edit-button {
    color: #ff9900;
    border-color: #ff9900;
    transition: all 0.2s;
    &:hover {
      color: #fff;
      background: #ff9900;
    }
  }
}
</style>
